<template>
  <div>
    <b-card no-body class="rounded-xl border-none">
      <div class="mt-8">
        <b-input-group>
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <el-table
          class="table-responsive table-flush mt-6"
          header-row-class-name="thead-light table-th-color"
          :data="ScheduledSMSData"
        >
          <el-table-column label="User ID" min-width="90px" prop="uid" sortable>
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.uid }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Sender ID"
            min-width="100px"
            prop="Senderid"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.Senderid }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Campaign ID"
            min-width="100px"
            prop="Campaignid"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.Campaignid }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Content"
            min-width="180px"
            prop="content"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.content }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Total Count"
            min-width="100px"
            prop="totalCount"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.totalCount }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Schedule Time"
            min-width="140px"
            prop="Schedule"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.Schedule }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Action"
            min-width="100px"
            prop="action"
            sortable
          >
            <template>
              <div class="flex items-center">
                <div class="flex items-center cursor-pointer">
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-5"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Delete"
                  ></feather-icon>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <base-pagination
            v-model="currentPage"
            :per-page="10"
            :total="50"
          ></base-pagination>
        </b-card-footer>
      </div>
    </b-card>
  </div>
</template>
<script>
import ScheduledSMSData from "./ScheduledSMSData";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      ScheduledSMSData,
      currentPage: 1,
      isDetailsActive: false,
      isShowCreate: false,
    };
  },
  methods: {
    toggleDetails(val = false) {
      this.isDetailsActive = val;
    },
  },
};
</script>
